export const buildQaLabel = (labels: string[], separator = "-") =>
  labels.join(separator);
